import { Icon } from './Icon';

/**
 * Значки таббара: те же тонкие контуры, что и у остальных, но крупнее и с
 * полем 22×22 — так они набраны в макетах. Вкуишные Icon28* здесь не годятся
 * по той же причине, что и везде: они сплошные и в своей палитре, и рядом с
 * контурной навигацией Мезы читаются как чужая панель.
 */

const SIZE = 21;

/**
 * Реестр: карточка личного дела — портрет и строки записи.
 *
 * Была сетка 2×2, но четыре плитки читаются как КАТАЛОГ: категории, разделы.
 * Реестр — это список личного состава, и значок должен говорить «человек с
 * записью», а не «витрина».
 */
export function TabRegistryIcon() {
  return (
    <Icon size={SIZE} box={22} strokeWidth={1.2}>
      <rect x="2.2" y="3.4" width="17.6" height="15.2" />
      <circle cx="7.9" cy="9.2" r="2.2" />
      <path d="M4.7 15.4 q3.2 -2.9 6.4 0" />
      <path d="M13.4 8.4 h3.6" />
      <path d="M13.4 12 h3.6" />
    </Icon>
  );
}

/** Внешки: кадр с лицом. */
export function TabFacesIcon() {
  return (
    <Icon size={SIZE} box={22} strokeWidth={1.2}>
      <rect x="2.2" y="2.2" width="17.6" height="17.6" />
      <circle cx="11" cy="9" r="3.1" />
      <path d="M5.8 17.6 q5.2 -4.8 10.4 0" />
    </Icon>
  );
}

/** Персонаж: сота с лицом — тот же силуэт, что у карточки аккаунта. */
export function TabCharacterIcon() {
  return (
    <Icon size={SIZE} box={24} strokeWidth={1.2}>
      <path d="M11 1.4 L19.6 6.2 V17.8 L11 22.6 L2.4 17.8 V6.2 Z" />
      <circle cx="11" cy="10" r="2.5" />
      <path d="M6.8 17.4 q4.2 -3.6 8.4 0" />
    </Icon>
  );
}

/** Задачи: лист с отметкой проверки. */
export function TabTasksIcon() {
  return (
    <Icon size={SIZE} box={22} strokeWidth={1.2}>
      <rect x="2.4" y="2.4" width="17.2" height="17.2" />
      <path d="M6 8.2 h6" />
      <path d="M6 12.4 h4.4" />
      <path d="M12.6 14.4 l2 2 l3.4 -4.4" />
    </Icon>
  );
}

/** Ещё: три точки. */
export function TabMoreIcon() {
  return (
    <Icon size={SIZE} box={22} strokeWidth={1.2}>
      <circle cx="4.6" cy="11" r="1.8" />
      <circle cx="11" cy="11" r="1.8" />
      <circle cx="17.4" cy="11" r="1.8" />
    </Icon>
  );
}
